import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import HeaderBread from "../../../components/HeaderBread";
import SailingDateDataInput from "../../../components/NewsLetter/SailingDateData";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import { getSailingPageData } from "../../../utils/ApiCalls/SailingData";
import SailingPageDuplicateInput from "../../../components/NewsLetter/SailingPageDuplicateInput";

const EditDuplicateSailingPages = () => {
  const params = useParams();
  const [newsletter, setSailingData] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Cruise",
      route: "/shore/cruise-page/genting-dream",
    },
    {
      title: "Duplicate Cruise",
      route: "/shore/cruise-page/genting-dream/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getSailingPageData({ id: value });

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.count === 1) {
      setSailingData(data.data[0]);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"Genting Dream"}>
      <CustomHeaderTitle title={"Duplicate Cruise"} />
      <HeaderBread
        navigation={navigation}
        title={"Duplicate Cruise"}
      ></HeaderBread>
      {newsletter && <SailingPageDuplicateInput newsletter={newsletter} />}
    </Layout>
  );
};

export default EditDuplicateSailingPages;
